'use client';

import React from 'react';
import BaseSwiper from '@/components/seo/swiper/BaseSwiper';
import JobTitleCard from '@/components/seo/job-title/JobTitleCard';
import { GroupedHotJotTitlesType } from '@/types/job-title';

const HobJobsSalary = ({
  hotJobTitles,
}: {
  hotJobTitles: GroupedHotJotTitlesType;
}) => {
  const [jobCategoryId, setJobCategoryId] = React.useState<string>(
    hotJobTitles?.length > 0 ? hotJobTitles[0].id : '',
  );

  if (!Array.isArray(hotJobTitles) || !hotJobTitles.length) {
    return null;
  }

  return (
    <div className="my-16">
      <h3 className="text-2xl font-semibold mb-10">职位薪酬</h3>
      <div className="relative">
        <h4 className="flex gap-4 mb-8 overflow-x-scroll tablet:overflow-auto">
          {hotJobTitles.map(({ id, name }, index) => (
            <span
              role="button"
              key={id + index}
              data-selected={id === jobCategoryId}
              className="px-8 py-2 rounded-full text-sm border border-web-tertiary font-semibold whitespace-nowrap transition-colors duration-250 data-[selected=true]:text-white data-[selected=true]:bg-web-blue-500 data-[selected=true]:border-web-blue-600 data-[selected=false]:hover:bg-web-blue-500/4 data-[selected=false]:hover:border-web-blue-600"
              onClick={() => setJobCategoryId(id)}
            >
              {`${name}类`}
            </span>
          ))}
        </h4>
        {hotJobTitles.map(({ id, job_titles }) => (
          <div key={id} hidden={id !== jobCategoryId} className="w-full">
            <BaseSwiper
              chunkData={job_titles}
              swiperEle={({ ...data }) => (
                <JobTitleCard key={data.id} {...data} />
              )}
              showNavigation={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HobJobsSalary;
